module.exports = __webpack_public_path__ + "img/formsRechteck.3dde5a1b.svg";